import { html, View } from 'rune-ts';

export type RotationModalData = {
  candidates: readonly number[]; // 길이 1 또는 2
  onPick: (resolvedNumber: number) => void;
  onCancel: () => void;
};

export class RotationModalView extends View<RotationModalData> {
  override template() {
    const { candidates } = this.data;
    const buttons = candidates.map(
      (n) => html`
        <button
          type="button"
          data-num="${n}"
          data-role="pick"
          class="rotation-pick rounded-2xl bg-card-navy text-card-gold text-3xl font-extrabold w-24 h-24 shadow hover:bg-card-deep transition"
        >
          ${n}
        </button>
      `,
    );
    return html`
      <div class="rotation-modal fixed inset-0 z-50 flex items-center justify-center bg-wood-coffee/70 p-4">
        <div class="bg-wood-paper rounded-2xl ring-1 ring-card-gold/50 p-5 w-full max-w-sm flex flex-col gap-4">
          <h2 class="text-lg font-bold text-center text-wood-ink">이 타일을 어떻게 사용할까요?</h2>
          <div class="flex items-center justify-center gap-4">${buttons}</div>
          <p class="text-xs text-wood-coffee/70 text-center">※ 한 번 결정하면 영원히 고정됩니다</p>
          <button
            type="button"
            data-role="cancel"
            class="rounded-xl bg-wood-bark hover:bg-wood-coffee text-wood-paper py-2 text-sm"
          >
            취소
          </button>
        </div>
      </div>
    `;
  }

  protected override onMount(): void {
    const root = this.element();
    root.querySelectorAll<HTMLButtonElement>('[data-role="pick"]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const num = Number(btn.dataset.num);
        if (Number.isFinite(num)) this.data.onPick(num);
      });
    });
    root.querySelector<HTMLButtonElement>('[data-role="cancel"]')?.addEventListener('click', () => {
      this.data.onCancel();
    });
  }
}
